import React, { useCallback, useState } from 'react';

import SearchText from 'components/SearchText';
import ChatStatusAlert from '../ChatStatusAlert';
import ChannelsThread from '../ChannelsThread';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

const ChatDrawerContent = ({ wrapperProps = {}, documentId }) => {
  const [searchValue, setSearchValue] = useState('');

  const handleSearchChange = useCallback((value) => {
    setSearchValue(value);
  }, []);

  return (
    <Box display="flex" flexDirection="column" overflow="hidden" {...wrapperProps}>
      <Box p={2}>
        <ChatStatusAlert />
        <SearchText
          size="small"
          onChangeSearchText={handleSearchChange}
          searchText={searchValue}
          slotProps={{
            input: { sx: { borderRadius: 5 } },
          }}
        />
      </Box>
      <Divider />
      <ChannelsThread searchText={searchValue} documentId={documentId} />
    </Box>
  );
};

export default ChatDrawerContent;
